var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12 5.30001V21.33C11.83 21.33 11.65 21.3 11.51 21.22L11.47 21.2C9.55 20.15 6.2 19.05 4.03 18.76L3.74 18.72C2.78 18.6 2 17.7 2 16.74V4.66001C2 3.47001 2.97 2.57001 4.16 2.67001C6.26 2.84001 9.44 3.90001 11.22 5.01001L11.47 5.16001C11.62 5.25001 11.81 5.30001 12 5.30001Z",
    fill: "#F66962"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4.67V16.74C22 17.7 21.22 18.6 20.26 18.72L19.93 18.76C17.75 19.05 14.39 20.16 12.47 21.22C12.34 21.3 12.18 21.33 12 21.33V5.3C12.19 5.3 12.38 5.25 12.53 5.16L12.7 5.05C14.48 3.93 17.67 2.86 19.77 2.68H19.83C21.02 2.58 22 3.47 22 4.67Z",
    fill: "#F66962"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 9.23999H5.5C5.09 9.23999 4.75 8.89999 4.75 8.48999C4.75 8.07999 5.09 7.73999 5.5 7.73999H7.75C8.16 7.73999 8.5 8.07999 8.5 8.48999C8.5 8.89999 8.16 9.23999 7.75 9.23999Z",
    fill: "#F66962"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.24H5.5C5.09 12.24 4.75 11.9 4.75 11.49C4.75 11.08 5.09 10.74 5.5 10.74H8.5C8.91 10.74 9.25 11.08 9.25 11.49C9.25 11.9 8.91 12.24 8.5 12.24Z",
    fill: "#F66962"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon01);
export default __webpack_public_path__ + "static/media/icon-01.84fb8184e6f90ae5e46dd7d55e77abfc.svg";
export { ForwardRef as ReactComponent };